export const HOME_SAVE_TOKEN_FROM_ORGANIZATION = 'HOME_SAVE_TOKEN_FROM_ORGANIZATION';
export const HOME_LOAD_PROJECT_DETAIL_BEGIN = 'HOME_LOAD_PROJECT_DETAIL_BEGIN';
export const HOME_LOAD_PROJECT_DETAIL_SUCCESS = 'HOME_LOAD_PROJECT_DETAIL_SUCCESS';
export const HOME_LOAD_PROJECT_DETAIL_FAILURE = 'HOME_LOAD_PROJECT_DETAIL_FAILURE';
export const HOME_LOAD_PROJECT_DETAIL_DISMISS_ERROR = 'HOME_LOAD_PROJECT_DETAIL_DISMISS_ERROR';
export const HOME_HIDE_PROJECT_WELCOME_POPUP_BEGIN = 'HOME_HIDE_PROJECT_WELCOME_POPUP_BEGIN';
export const HOME_HIDE_PROJECT_WELCOME_POPUP_SUCCESS = 'HOME_HIDE_PROJECT_WELCOME_POPUP_SUCCESS';
export const HOME_HIDE_PROJECT_WELCOME_POPUP_FAILURE = 'HOME_HIDE_PROJECT_WELCOME_POPUP_FAILURE';
export const HOME_HIDE_PROJECT_WELCOME_POPUP_DISMISS_ERROR = 'HOME_HIDE_PROJECT_WELCOME_POPUP_DISMISS_ERROR';
export const HOME_ADD_LAST_ACCESS_BEGIN = 'HOME_ADD_LAST_ACCESS_BEGIN';
export const HOME_ADD_LAST_ACCESS_SUCCESS = 'HOME_ADD_LAST_ACCESS_SUCCESS';
export const HOME_ADD_LAST_ACCESS_FAILURE = 'HOME_ADD_LAST_ACCESS_FAILURE';
export const HOME_ADD_LAST_ACCESS_DISMISS_ERROR = 'HOME_ADD_LAST_ACCESS_DISMISS_ERROR';

